import Vue from "vue";
import Vuelidate from "vuelidate";
import Firebase from "firebase/app";
import "firebase/storage";
import "firebase/auth";
import { IonicVueRouter } from "@ionic/vue";
import routes from "./router/index";
import store from "./store/store";
import AxiosPlugin from "./AxiosPlugin";
import FirebasePlugin from "./FirebasePlugin";

import Ionic from "@ionic/vue";
import App from "./App.vue";
import MainHeader from "@/components/Shared/MainHeader";
import InputBox from "@/components/Shared/InputBox";
import AvailableOrderFooter from "@/components/App/AvailableOrderFooter";
import LoadingSpinner from "@/components/Shared/LoadingSpinner";

import AuthMiddleware from "./router/middleware/auth";

import { centsToDollars } from "@/util";

import "@ionic/core/css/core.css";
import "@ionic/core/css/ionic.bundle.css";

import { addIcons } from "ionicons";
import {
  home,
  logOut,
  person,
  planet,
  people,
  navigate,
  compass,
  add,
  restaurant,
  time,
  card,
  helpBuoy,
  pricetags,
  cloudDownload,
  stats,
  walk,
  basket
} from "ionicons/icons";

import titleMixin from "@/mixins/title";

Vue.config.productionTip = false;

Vue.component("main-header", MainHeader);
Vue.component("input-box", InputBox);

// maybe in the future we should make this only for mobile?
Vue.component("available-order-footer", AvailableOrderFooter);

Vue.component("loading-spinner", LoadingSpinner);

Vue.use(AxiosPlugin);

Vue.use(FirebasePlugin);

Vue.use(Ionic);

addIcons({
  "ios-home": home.ios,
  "md-home": home.md,
  "ios-log-out": logOut.ios,
  "md-log-out": logOut.md,
  "ios-person": person.ios,
  "md-person": person.md,
  "ios-planet": planet.ios,
  "md-planet": planet.md,
  "ios-people": people.ios,
  "md-people": people.md,
  "ios-navigate": navigate.ios,
  "md-navigate": navigate.md,
  "ios-compass": compass.ios,
  "md-compass": compass.md,
  "ios-add": add.ios,
  "md-add": add.md,
  "ios-time": time.ios,
  "md-time": time.md,
  "ios-restaurant": restaurant.ios,
  "md-restaurant": restaurant.md,
  "ios-card": card.ios,
  "md-card": card.md,
  "ios-help-buoy": helpBuoy.ios,
  "md-help-buoy": helpBuoy.md,
  "ios-pricetags": pricetags.ios,
  "md-pricetags": pricetags.md,
  "ios-cloud-download": cloudDownload.ios,
  "md-cloud-download": cloudDownload.md,
  "ios-stats": stats.ios,
  "md-stats": stats.md,
  "ios-walk": walk.ios,
  "md-walk": walk.md,
  "ios-basket": basket.ios,
  "md-basket": basket.md
});

Vue.use(Vuelidate);
Vue.use(IonicVueRouter);

const toast = (type, message) => {
  const controller = document.querySelector("ion-toast-controller");
  return controller
    .create({
      color: type,
      duration: 6000,
      message,
      showCloseButton: true
    })
    .then(toast => {
      return toast.present();
    });
};

Vue.mixin({
  methods: {
    /**
     * Will show a regular alert for things in progress
     */
    wip() {
      alert("Work in Progress!");
    },

    /**
     * A success toast message
     * @param {*} message
     * @return Promise
     */
    successToast(message) {
      return toast("success", message);
    },

    /**
     * An info toast message
     * @param {*} message
     * @return Promise
     */
    infoToast(message) {
      return toast("light", message);
    }
  }
});

Vue.mixin(titleMixin);

Vue.directive("super-long-press", {
  bind: function(el, binding, vNode) {
    if (typeof binding.value !== "function") {
      const compName = vNode.context.name;
      let warn = `v-longpress provided expression '${binding.expression}' is not a function, but needs to be.`;
      if (compName) {
        warn += ` Found in component '${compName}' `;
      }
      /* eslint no-console: ["error", { allow: ["warn"] }] */
      console.warn(warn);
      return;
    }

    let pressTimer = null;

    let start = e => {
      if (e.type === "click" && e.button !== 0) {
        return;
      }

      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          handler();
        }, 5000);
      }
    };

    let cancel = () => {
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    };

    const handler = e => {
      binding.value(e);
    };

    // Add Event listeners
    el.addEventListener("mousedown", start);
    el.addEventListener("touchstart", start);
    // Cancel timeouts if this events happen
    el.addEventListener("click", cancel);
    el.addEventListener("mouseout", cancel);
    el.addEventListener("touchend", cancel);
    el.addEventListener("touchcancel", cancel);
  }
});

Vue.filter("ucfirst", value => {
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("usd", value => {
  if (typeof value === "undefined" || value === "") {
    return "";
  }
  let dollars = parseFloat(centsToDollars(value));
  return dollars.toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });
});

const router = new IonicVueRouter({
  mode: "history",
  routes
});

router.beforeEach(AuthMiddleware);

// this will clear the order if they choose a new location (technically if they choose the same location, too - might seem buggy)
store.watch(
  state => state.order.location,
  () => {
    store.commit("order/clearOrder");
  }
);

let app = null;

Firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});
